export const ROUTES = {
  ROOT: "/",
  SKYDIVING_FORM: "/para",
  VOLUNTARY_OCCURRENCE_FORM: "/voluntary-occurrence",
  MANDATORY_OCCURRENCE_FORM: "/mandatory-occurrence",
  ANNEX_1_AIRCRAFT: "/annex-1-aircraft",
  ECCAIRS_PDF_UPLOAD_FORM: "/eccairs-pdf"
};
